<template>
  <v-container>
    <v-tabs v-model="tabs">
    <v-tab>Daily visualisation</v-tab>
    <v-tab>Rain events visualisation</v-tab>
    <v-tab>Long-term monitoring</v-tab>

    <v-tab-item>
      <v-container style="padding:25px 0px 25px 0px;">
      <v-row class="text-center">
      <v-col cols="6" style="padding:0px 10px 0px 20px; margin:0px;">
        <v-select
          :items="sites"
          v-model="site"
          label="Select site"
          dense
          solo
          prepend-icon="mdi-map-marker-radius-outline"
        ></v-select>
      </v-col>
      <v-col cols="6" style="padding:0px 20px 0px 10px; margin:0px;">
        <v-select
          :items="radars"
          v-model="radar"
          label="Select radar type / disdro type"
          dense
          solo
          prepend-icon="mdi-satellite-uplink"
          @change="changeRadar()"
        ></v-select>
      </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" style="padding:0px 10px 0px 20px; margin:0px;">
          <v-date-picker show-adjacent-months v-model="selectedDate" @change="displayQLs()" elevation="5" 
            full-width
            :max="nowDate"
            class="mt-4"
            style="padding:0px; margin:0px;"
            ></v-date-picker>
          <v-card
            elevation="5"
            v-if="selectedConf != ''"
            style="margin-top:10px"
          >
            <v-list dense>
              <v-subheader>Information</v-subheader>
              <v-list-item-group
                color="primary"
              >
                <v-list-item>
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-information</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>Radar: <a :href="selectedConf.radar_pid" target="_blank">{{ selectedConf.radar_type }}</a></small>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-information</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>Disdro: <a :href="selectedConf.disdro_pid" target="_blank">{{ selectedConf.disdro_type }}</a></small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <v-divider></v-divider>
              <v-subheader>Download related data</v-subheader>
              <v-list-item-group
                color="primary"
                v-if="outputFiles.length>0"
              >
                <v-list-item
                  v-for="(item, i) in outputFiles"
                  :key="i"
                >
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-download</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>{{item.type}} file: <a :href="item.url" target="_blank">{{item.text}}</a></small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <v-list-item-group
                color="primary"
                v-else
              >
                <v-list-item
                >
                  <v-list-item-content>
                    <small>No data for this day</small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="9" style="padding:0px 20px 0px 10px; margin:0px;">
          <div v-if="noData">    
            <v-alert  prominent outlined  border="left" type="warning" style="margin-top:16px" >
              There is no data for this day.
            </v-alert>
        </div>
        <div v-else>
          <div v-for="(item, i) in outputQLs" :key="i">
            <a :href="item.url" target="_blank"><v-img :src="item.url" :title="item.type">
            </v-img></a>
          </div>
        </div>
        </v-col>
      </v-row>
    </v-container>
    </v-tab-item>





    
    <v-tab-item>

      <v-row class="text-center" style="padding:25px 0px 0px 0px;">
      <v-col cols="6" style="padding:0px 10px 0px 20px; margin:0px;">
        <v-select
          :items="sites"
          v-model="site"
          label="Select site"
          dense
          solo
            prepend-icon="mdi-map-marker-radius-outline"
        ></v-select>
      </v-col>
      <v-col cols="6" style="padding:0px 20px 0px 10px; margin:0px;">
        <v-select
          :items="radars"
          v-model="radar"
          label="Select radar type / disdro type"
          dense
          solo
            prepend-icon="mdi-satellite-uplink"
          @change="changeRadar2()"
        ></v-select>
      </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" style="padding:0px 10px 0px 20px; margin:0px;">
          <v-date-picker show-adjacent-months v-model="selectedDate" @change="displayQLs2()" elevation="5" 
            full-width
            :max="nowDate"
            class="mt-4"
            style="padding:0px; margin:0px;"
            ></v-date-picker>
          <v-card
            elevation="5"
            v-if="selectedConf != ''"
            style="margin:10px 0px 20px 0px"
          >
            <v-list dense>
              <v-subheader>Information</v-subheader>
              <v-list-item-group
                color="primary"
              >
                <v-list-item>
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-information</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>Radar: <a :href="selectedConf.radar_pid" target="_blank">{{ selectedConf.radar_type }}</a></small>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-information</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>Disdro: <a :href="selectedConf.disdro_pid" target="_blank">{{ selectedConf.disdro_type }}</a></small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <v-divider></v-divider>
              <v-subheader>Download related data</v-subheader>
              <v-list-item-group
                color="primary"
                v-if="outputFiles2.length>0"
              >
                <v-list-item
                  v-for="(item, i) in outputFiles2"
                  :key="i"
                >
                  <v-list-item-icon style="margin-right:0px">
                    <v-icon small>mdi-download</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <small>{{item.type}} file: <a :href="item.url" target="_blank">{{item.text}}</a></small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <v-list-item-group
                color="primary"
                v-else
              >
                <v-list-item
                >
                  <v-list-item-content>
                    <small>No data for this day</small>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="9" style="padding:0px 20px 0px 10px; margin:0px;">
          <div v-if="noData2">    
            <v-alert  prominent outlined  border="left" type="warning" style="margin-top:16px" >
              There is no data for this day.
            </v-alert>
        </div>
        <div v-else>
          <div v-for="(item, i) in outputQLs2" :key="i">
            <a :href="item.url" target="_blank"><v-img :src="item.url" :title="item.type">
            </v-img></a>
          </div>
        </div>
        </v-col>
      </v-row>
</v-tab-item>
<v-tab-item>
  <strong>(Soon available)</strong>
</v-tab-item>
  </v-tabs>
  
    
  </v-container>
</template>

<script>
import axios from 'axios';


  export default {
    name: 'ccres-visu',

    data: () => ({
      disdroURL: "https://data.ipsl.fr/repository/ccres/disdro/",
      ccresdata: null,
      site: "",
      radar: "",
      radars: [],
      sites: [],
      selectedConf: "",
      selectedDate: null,
      nowDate: null,
      outputFiles: [],
      outputQLs: [],
      outputFiles2: [],
      outputQLs2: [],
      noData: false,  
      noData2: false,      
        tabs: 0,
    }),

    created() {
    },

    mounted() {
      this.getCCRESConfig();

      // Créer une nouvelle instance de Date
      var date = new Date();
      date.setDate(date.getDate() - 1);

      // Obtenez l'année, le mois et le jour
      var year = date.getUTCFullYear();
      var month = ('0' + (date.getUTCMonth() + 1)).slice(-2); // Ajouter 1 car les mois commencent à 0
      var day = ('0' + date.getUTCDate()).slice(-2);

      // Créer la date au format YYYY-MM-DD
      this.nowDate = year + '-' + month + '-' + day;
      this.selectedDate = year + '-' + month + '-' + day;


    },

    watch: {
      ccresdata: function (newVal, oldVal) {
        console.log(newVal);
        console.log(oldVal);
      
        for (let i = 0; i < this.ccresdata.length; i++) {
          this.sites.push( this.ccresdata[i].site)
        }
      },
      tabs: function (newVal, oldVal) {
        console.log(newVal);
        console.log(oldVal);
        
        switch(newVal) {
            case 0:
              this.changeRadar()
              break;
            case 1:
              this.changeRadar2()
              break;
          }
      },
      site: function (newVal, oldVal) {
        console.log(newVal);
        console.log(oldVal);
        this.radars = [];
        this.radar = "";
        this.selectedConf = "";
        this.outputFiles= [];
        this.outputQLs= [];
        this.noData = false;
        this.outputFiles2= [];
        this.outputQLs2= [];
        this.noData2 = false;
      
        for (let i = 0; i < this.ccresdata.length; i++) {
          if(this.ccresdata[i].site == newVal) {
            for (let j = 0; j < this.ccresdata[i].conf.length; j++) {
              let rip = this.ccresdata[i].conf[j].radar_pid
              let rip2 = rip.substring(rip.indexOf('3.')+2, rip.indexOf('3.')+11)
              this.radars.push(this.ccresdata[i].conf[j].radar_type + '(' + rip2 +')' + ' / ' + this.ccresdata[i].conf[j].disdro_type)
            }
          }
        }
        if(this.radars.length>0) {
          this.radar = this.radars[0]
          switch(this.tabs) {
            case 0:
              this.changeRadar()
              break;
            case 1:
              this.changeRadar2()
              break;
          }
        }
      }
    },

    methods: {
      getCCRESConfig() {
        axios.get(this.disdroURL + "ccres_disdro_processing_conf.json").then(json => (this.ccresdata = json.data));
            
      },
      changeRadar() {
        for (let i = 0; i < this.ccresdata.length; i++) {
          if(this.ccresdata[i].site == this.site) {
            for (let j = 0; j < this.ccresdata[i].conf.length; j++) {
              let rip = this.ccresdata[i].conf[j].radar_pid
              let rip2 = rip.substring(rip.indexOf('3.')+2, rip.indexOf('3.')+11)
              if(this.ccresdata[i].conf[j].radar_type + '(' + rip2 +')' + ' / ' + this.ccresdata[i].conf[j].disdro_type  == this.radar)
                this.selectedConf = this.ccresdata[i].conf[j];
            }
          }
        }

        this.displayQLs();

      },
      changeRadar2() {
        for (let i = 0; i < this.ccresdata.length; i++) {
          if(this.ccresdata[i].site == this.site) {
            for (let j = 0; j < this.ccresdata[i].conf.length; j++) {
              let rip = this.ccresdata[i].conf[j].radar_pid
              let rip2 = rip.substring(rip.indexOf('3.')+2, rip.indexOf('3.')+11)
              if(this.ccresdata[i].conf[j].radar_type + '(' + rip2 +')' + ' / ' + this.ccresdata[i].conf[j].disdro_type  == this.radar)
                this.selectedConf = this.ccresdata[i].conf[j];
            }
          }
        }

        this.displayQLs2();

      },
      displayQLs() {
        if(this.selectedConf == '') {
          alert('Select a site and a radar configuration!')
        }
        else {
          this.outputFiles = [];
          this.outputQLs = [];
          let verifFile = "";
          for (var cle in this.selectedConf.output.preprocessing) {
            let ds = this.selectedDate.split('-');
            let tmp = this.selectedConf.output.preprocessing[cle];
            tmp = tmp.replace('%Y', ds[0]);
            tmp = tmp.replace('%m', ds[1]);
            tmp = tmp.replace('%d', ds[2]);
            let outputFile = {text:'', url: '', type: ''};
            outputFile.url = this.disdroURL + this.site + '/' + ds[0] + '/' + ds[1] + '/' + ds[2] + '/' + tmp;
            verifFile = outputFile.url;
            outputFile.text = tmp;
            outputFile.type = cle;
            this.outputFiles.push(outputFile)          
          }

          for (var cle2 in this.selectedConf.output.preprocessing_ql) {          
            let ds = this.selectedDate.split('-');
            let tmp = this.selectedConf.output.preprocessing_ql[cle2];
            tmp = tmp.replace('%Y', ds[0]);
            tmp = tmp.replace('%m', ds[1]);
            tmp = tmp.replace('%d', ds[2]);
            let outputQL = {text:'', url: '', type: ''};
            outputQL.url = this.disdroURL + this.site + '/' + ds[0] + '/' + ds[1] + '/' + ds[2] + '/' + tmp;
            outputQL.text = tmp;
            outputQL.type = cle2;
            this.outputQLs.push(outputQL)          
          }        
          
          this.verifierExistenceFichier(verifFile);
        }
      },
      displayQLs2() {
        if(this.selectedConf == '') {
          alert('Select a site and a radar configuration!')
        }
        else {
          this.outputFiles2 = [];
          this.outputQLs2 = [];
          let verifFile = "";
          for (var cle in this.selectedConf.output.processing) {
            let ds = this.selectedDate.split('-');
            let tmp = this.selectedConf.output.processing[cle];
            tmp = tmp.replace('%Y', ds[0]);
            tmp = tmp.replace('%m', ds[1]);
            tmp = tmp.replace('%d', ds[2]);
            let outputFile = {text:'', url: '', type: ''};
            outputFile.url = this.disdroURL + this.site + '/' + ds[0] + '/' + ds[1] + '/' + ds[2] + '/' + tmp;
            verifFile = outputFile.url;
            outputFile.text = tmp;
            outputFile.type = cle;
            this.outputFiles2.push(outputFile)          
          }

          for (var cle2 in this.selectedConf.output.processing_ql) {          
            let ds = this.selectedDate.split('-');
            let tmp = this.selectedConf.output.processing_ql[cle2];
            tmp = tmp.replace('%Y', ds[0]);
            tmp = tmp.replace('%m', ds[1]);
            tmp = tmp.replace('%d', ds[2]);
            let outputQL = {text:'', url: '', type: ''};
            outputQL.url = this.disdroURL + this.site + '/' + ds[0] + '/' + ds[1] + '/' + ds[2] + '/' + tmp + '_00.png';
            outputQL.text = tmp;
            outputQL.type = cle2;
            this.outputQLs2.push(outputQL)          
          }        
          
          this.verifierExistenceFichier2(verifFile);
        }
      },
      
      // Fonction pour vérifier si le fichier existe
      async  verifierExistenceFichier(url) {
          try {
              const response = await axios.head(url);
              // Si le statut de réponse est 200, le fichier existe
              if (response.status === 200) {
                  console.log('Le fichier existe en ligne.');
                  this.noData = false;
              } else {
                  console.log('Le fichier n\'existe pas en ligne.');
                  this.outputFiles = [];
                  this.outputQLs = [];
                  this.noData = true;
              }
          } catch (error) {
              // En cas d'erreur (ex : 404), le fichier n'existe probablement pas
              console.error('Erreur lors de la vérification de l\'existence du fichier :', error.message);
              this.outputFiles = [];
              this.outputQLs = [];
              this.noData = true;
          }
      },
      // Fonction pour vérifier si le fichier existe
      async  verifierExistenceFichier2(url) {
          try {
              const response = await axios.head(url);
              // Si le statut de réponse est 200, le fichier existe
              if (response.status === 200) {
                  console.log('Le fichier existe en ligne.');
                  this.noData2 = false;
              } else {
                  console.log('Le fichier n\'existe pas en ligne.');
                  this.outputFiles2 = [];
                  this.outputQLs2 = [];
                  this.noData2 = true;
              }
          } catch (error) {
              // En cas d'erreur (ex : 404), le fichier n'existe probablement pas
              console.error('Erreur lors de la vérification de l\'existence du fichier :', error.message);
              this.outputFiles2 = [];
              this.outputQLs2 = [];
              this.noData2 = true;
          }
      },
    }
  }
</script>
